import { CustomizedShowArrType } from '../../api/define';

export enum AjaxType {
    /** 请求中 | 还未请求 */
    PENDING = 'pending',
    /** 请求失败 */
    REJECT = 'reject',
    /** 请求成功 */
    RESOVLE = 'resovle',
}

/**
 * 一个页面地址与一个降级场景Key的对应关系
 */
export type DemotionConfigEntry = {
    /** 页面地址 */
    page: string;
    /** 降级场景key */
    key: string;
};

export interface IState {
    /** 当前门店名称 */
    wmPoiName: string;
    /**
     * 当前账号是否关联了多个门店
     * 0：当前账号只绑定了1个门店（200账号 or 300账号但是只有1个门店）
     * 1：300账号且绑定了多个门店
     * */
    isChain: 0 | 1;
    /** 当前门店营业状态描述文案 */
    wmPoiStatusDesc: string;
    /** 当前账号名称 */
    acctName: string;
    /** 当前账号是否绑定手机 */
    hasBoundPhone: boolean;
    /**
     * 定制化配置
     *  searchBox: 搜索框； printIcon: 打印icon; businessState: 门店营业状态; wmPoiIdAll: 查看全部门店; IM; pushMessage: 消息推送
     * */
    customizedShowArr: CustomizedShowArrType[];
    /** 非SLA商家7折赔付弹框 */
    compensateProtocolModalVisibility: boolean;
    /** 门店列表接口是否状态 */
    poilistAjaxType: AjaxType;
    /** 降级轮询配置信息 */
    demotionConfig: DemotionConfigEntry[];
    /** 当前生效中的降级文案 */
    activeDemotionContext: string;
}

const shellCommon = {
    name: 'shellCommon',
    state: {
        wmPoiName: '',
        isChain: 0,
        wmPoiStatusDesc: '',
        acctName: '',
        hasBoundPhone: false,
        customizedShowArr: [],
        compensateProtocolModalVisibility: false,
        poilistAjaxType: AjaxType.PENDING,
        demotionConfig: [],
        activeDemotionContext: '',
    } as IState,
    reducers: {
        setData(state: IState, payload: Partial<IState>) {
            return {
                ...state,
                ...payload,
            };
        },
        changeCompensateProtocolModalVisibility(state: IState, payload: boolean) {
            return {
                ...state,
                compensateProtocolModalVisibility: payload,
            };
        },
    },
    effects: () => ({}),
};

export default shellCommon;
